import React, { Component } from 'react';
import { useImage } from 'react-image'
import{imagePath}  from '../common'
export function TestinomialComponent(props) {
   
    const { src } = useImage({
        srcList:imagePath+ props.item.customer_image
    })
    return (
        <div class="test-m-div" >
        <div className="test-m-bx">
            <div>
                <span className="quote">”</span>
            </div>
            <div className="test-m-desc">
                <div className="test-img">
                    <img src={src} alt="Awesome" />
                </div>
                <div className="desc-rte">
                    <h2>{props.item.customer_name}</h2>
                    <p>{props.item.customer_description}</p>
                    <span className="test-title">Duis posuere</span>
                </div>
            </div>
        </div>


    </div>
    )
}